/**
 * 게스트 챗 고지 — 게스트는 로그인하지 않으므로 처리방침의 "로그인 시 동의 간주"가
 * 닿지 않는다. 그래서 대화가 시작되는 자리에서 직접 알린다: 언어 게이트(첫 진입)에는
 * 전문을, 입력창 바로 위(재방문 포함, 메시지를 보내기 직전에 늘 보이는 자리)에는
 * 한 줄 요약을 둔다. 메시지 목록 안에 넣으면 ChatWindow가 mount 시 맨 아래로
 * 스크롤해 버려 보이지 않는다.
 *
 * 두 게스트 표면(/g/<token>, /p/<token>)이 같은 문구를 쓰도록 컴포넌트 하나로 둔다.
 * 링크는 라우터 밖에서 렌더되는 게이트에서도 쓰이므로 <Link>가 아니라 <a>이고,
 * 새 탭으로 열어 대화를 잃지 않게 한다. 국외 이전의 수탁자·국가 같은 상세는
 * 처리방침 제4조가 원본이라 여기서 되풀이하지 않는다.
 */
interface ChatDisclosureProps {
  /** 입력창 위에 상주하는 한 줄 요약. 기본값은 게이트용 전문. */
  compact?: boolean;
}

export function ChatDisclosure({ compact }: ChatDisclosureProps) {
  const policyLink = (
    <a
      href="/privacy"
      target="_blank"
      rel="noreferrer"
      className="font-medium text-primary underline underline-offset-2"
    >
      개인정보 처리방침
    </a>
  );

  if (compact) {
    return (
      <p className="bg-card/70 px-4 pt-2 text-center text-[11px] leading-relaxed text-muted-foreground backdrop-blur-md">
        답변은 AI가 생성해 정확하지 않을 수 있어요. 중요한 사항은 숙소 프런트에 확인해 주세요.{" "}
        {policyLink}
      </p>
    );
  }

  return (
    <p className="rounded-xl border border-border/50 bg-card/50 px-3.5 py-2.5 text-xs leading-relaxed text-muted-foreground">
      이 대화는 숙소 안내를 위해 처리되고 답변은 AI가 생성해요. 대화 내용은 답변을 만들기 위해 국외
      AI 서비스로 전송되고, 숙소 운영자는 안내를 보완하려고 대화 내용을 볼 수 있어요. 답변이
      정확하지 않을 수 있으니 예약·요금처럼 중요한 사항은 숙소 프런트에 확인해 주세요. {policyLink}
    </p>
  );
}
